export default __webpack_public_path__ + "static/logo-4522ba9cf45cdca1e2d973b841f8b85b.png";